/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddRestrictionRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/add_restriction.pb'
import {AddRestrictionResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/add_restriction.pb'


export const addRestriction = (request: AddRestrictionRequest, options?: CashRequestOptions) => post<AddRestrictionRequest, AddRestrictionResponse>("/2.0/cash/add-restriction", request, {...options, rejectOnError: true })